<div class="modal-header">
  <h4 class="cookie-consent-modal-title">{{'cookie_banner.modal_title' | translate}}</h4>
</div>

<div class="modal-body">
  <div class="cookie-consent-modal-description">{{ 'cookie_banner.modal_description' | translate }}
  </div>

  <div class="cookie-consent-modal-privacy-cookie-links">
    <a [href]="legalDocumentLinks.privacyPolicyHref" target="_blank">
      {{ 'generic.privacy_link' | translate }}
    </a>

    @if (legalDocumentLinks.hasCookiePolicy$ | async) {
      <a [href]="legalDocumentLinks.cookiePolicyHref" target="_blank">
        {{ 'generic.cookies_link' | translate }}
      </a>
    }
  </div>

  <hr>
  <form [formGroup]="form">
    <app-cookies-type type="functional"
                       title="cookie_banner.cookie_type.functional.title"
                       description="cookie_banner.cookie_type.functional.description"
                       [control]="form.controls.functional"/>
    <hr>
    <app-cookies-type type="performance"
                       title="cookie_banner.cookie_type.performance.title"
                       description="cookie_banner.cookie_type.performance.description"
                       [control]="form.controls.performance"/>
    <hr>
    <app-cookies-type type="marketing"
                       title="cookie_banner.cookie_type.marketing.title"
                       description="cookie_banner.cookie_type.marketing.description"
                       [control]="form.controls.marketing"/>
  </form>
</div>

<div class="modal-footer">
  <button class="btn btn-raised btn-primary"
          type="button"
          (click)="accept()">
    {{ 'cookie_banner.accept_all' | translate }}
  </button>
  <button class="btn btn-raised btn-primary"
          type="button"
          (click)="save()">
    {{ 'cookie_banner.save_choices' | translate }}
  </button>
</div>
